/**
 * @fileoverview Bandeau d'alerte opérationnelle pour les paiements.
 *
 * Le bandeau reste purement UI dans cette tranche : il lit les métriques mockées
 * et oriente l'agent vers la file d'anomalies sans appeler de service.
 */

import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@gnpc/ui';
import { DASHBOARD_METRICS } from '../../data/backoffice.ts';

export function AlertingBanner(): JSX.Element | null {
  if (DASHBOARD_METRICS.sgiFailedCount === 0) return null;

  return (
    <div className="border-danger/25 bg-danger/5 rounded-lg border p-3">
      {/* `text-[#991b1b]` (rouge foncé) et non `text-danger` (#dc2626) :
        * sur le fond teinté `bg-danger/5`, #dc2626 tombait sous le ratio
        * 4,5:1 exigé par axe `color-contrast`. Le DS n'expose pas de
        * nuance 700 du token danger — hex explicite en attendant. */}
      <div className="flex flex-col gap-3 text-sm md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-2 font-medium text-[#991b1b]">
          <AlertTriangle className="mt-0.5 size-4 shrink-0" />
          <p>
            {DASHBOARD_METRICS.sgiFailedCount} paiements encaissés (
            {DASHBOARD_METRICS.sgiFailedAmount.toLocaleString('fr-FR')} F CFA) ne sont pas enregistrés
            côté Quipux. Traitement requis.
          </p>
        </div>
        <Button
          asChild
          size="sm"
          variant="outline"
          className="border-danger/30 text-[#991b1b] hover:bg-danger/10 hover:text-[#991b1b]"
        >
          <Link to="/payments?sgi_status=FAILED">Voir les anomalies</Link>
        </Button>
      </div>
    </div>
  );
}
